import React from 'react';

const DemoBanner: React.FC = () => {
  return (
    <div className="w-full bg-[var(--color-warning-500)] text-white py-2 px-4 text-center text-sm font-medium z-50 relative">
      <div className="container mx-auto flex items-center justify-center gap-2">
        <svg
          className="w-5 h-5 flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
        <span>The website is working in Demo mode</span>
      </div>
    </div>
  );
};

export default DemoBanner;
